export class SolPolicyExceptionData  {
    itemName: string = '';
    actual: string = '';
    policy: string = '';
    variance: string = '';
    approver: string = '';
    approverEmailId: string = '';
    reasonForException: string = '';
}